<template>
  <div>
    <v-menu
      :attach="attach"
      ref="datePicker1Ref"
      v-model="menu"
      lazy
      full-width
      offset-y
      class="d-inline-block combobox-menu"
      transition="scale-transition"
      min-width="290px">
      <v-text-field
        class="outline"
        slot="activator"
        v-model="search"
        :label="label"
        :append-icon="search ? 'close' : null"
        :append-icon-cb="eraseText"
        @focus.native="menu = true"
        solo/>
      <vue-perfect-scroll class="option-list" :style="scrollStyle">
        <v-list>
          <v-list-tile
            v-for="(item, index) in filteredItems"
            :key="`combobox-item-${index}`"
            @click="selectItem(item)">
            <v-list-tile-title>{{ item[textField] }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </vue-perfect-scroll>
    </v-menu>
  </div>
</template>

<script>
import VuePerfectScroll from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScroll,
  },
  props: {
    attach: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    textField: {
      type: String,
      default: 'text',
    },
    valueField: {
      type: String,
      default: 'id',
    },
    label: {
      type: String,
      default: 'Elige un item',
    },
    value: {},
  },
  mounted() {
    if (this.value) {
      const selectedItem = this.items.find(item => item[this.valueField] === this.value);
      if (selectedItem) {
        this.search = selectedItem[this.textField];
      }
    }
  },
  data() {
    return {
      search: '',
      menu: false,
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item => 
        item[this.textField].toLowerCase().includes(this.search.toLowerCase())
      );
    },
    scrollStyle() {
      let height = 48 * this.filteredItems.length;
      if (height > 215) {
        height = 215;
      }
      return {
        '--scrollHeight':  `${height}px`,
      };
    }
  },
  methods: {
    selectItem(item) {
      this.search = item[this.textField];
      this.menu = false;
      this.$emit('input', item[this.valueField]);
    },
    eraseText() {
      this.search = '';
      this.$emit('input', '');
    },
  },
  watch: {
    value(value) {
      if (value) {
        const index = this.items.findIndex(item => item[this.valueField] === value);
        if (index >= 0) {
          this.search = this.items[index][this.textField];
        }
      }
    }
  }
};
</script>
<style scoped>
  .option-list {
    height: var(--scrollHeight);
  }
  .outline {
    border: 1px solid #393939;
    border-radius: 2px;
    box-shadow: 0px 0px 0px 0px transparent;
  }
</style>


// WEBPACK FOOTER //
// src/components/global/VCombobox.vue